// 操作类型
export const OPERATION_TYPES = {
    CLONE: 'clone',
    DELETE: 'delete',
    VISIBILITY: 'visibility',
  } as const;
  
  // 默认提示文本
  export const DEFAULT_TOOLTIPS = {
    [OPERATION_TYPES.CLONE]: '克隆',
    [OPERATION_TYPES.DELETE]: '删除',
    [OPERATION_TYPES.VISIBILITY]: '显示/隐藏',
  } as const;
  
  // 表单布局默认配置
  export const DEFAULT_FORM_LAYOUT = {
    layout: 'horizontal',
    labelAlign: 'right',
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
    colon: true,
    requiredMark: true,
  } as const;
  
  // 字段间距
  export const FIELD_SPACING = {
    SMALL: 8,
    MEDIUM: 16,
    LARGE: 24,
  } as const;
  
  // 面板主题
  export const PANEL_THEME = {
    dark: {
      BACKGROUND: '#1e1e1e',
      TEXT_COLOR: '#fff',
      TEXT_COLOR_SECONDARY: 'rgba(255, 255, 255, 0.45)',
      BORDER_COLOR: '#303030',
      HOVER_BACKGROUND: 'rgba(255, 255, 255, 0.08)',
      SELECTED_BACKGROUND: 'rgba(255, 255, 255, 0.1)',
      DISABLED_COLOR: 'rgba(255, 255, 255, 0.25)',
    },
    light: {
      BACKGROUND: '#ffffff',
      TEXT_COLOR: '#000000',
      TEXT_COLOR_SECONDARY: 'rgba(0, 0, 0, 0.45)',
      BORDER_COLOR: '#d9d9d9',
      HOVER_BACKGROUND: 'rgba(0, 0, 0, 0.04)',
      SELECTED_BACKGROUND: 'rgba(0, 0, 0, 0.06)',
      DISABLED_COLOR: 'rgba(0, 0, 0, 0.25)',
    }
  } as const;
  
  // 事件类型
  export const EVENT_TYPES = {
    SET_META: 'setMeta',
    UPDATE_VALUE: 'updateValue',
    BATCH_UPDATE: 'batchUpdate',
  } as const;
  
  // 字段类型
  export const FIELD_TYPES = {
    STRING: 'string',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    SELECT: 'select',
    RADIO: 'radio',
    CHECKBOX: 'checkbox',
    COLOR: 'color',
    DATE: 'date',
    TIME: 'time',
    DATETIME: 'datetime',
    TEXTAREA: 'textarea',
    CODE: 'code',
    COMPOSITE: 'composite',
  } as const;
  
  // 验证规则类型
  export const RULE_TYPES = {
    REQUIRED: 'required',
    PATTERN: 'pattern',
    MIN: 'min',
    MAX: 'max',
    LENGTH: 'length',
    VALIDATOR: 'validator',
  } as const;
  
  // 错误消息
  export const ERROR_MESSAGES = {
    NO_TARGET_PATH: '未选择目标路径',
    FIELD_NOT_FOUND: '未找到指定字段',
    INVALID_META: '无效的元数据结构',
    OPERATION_FAILED: '操作失败',
  } as const;
  
  // 动画时长
  export const ANIMATION_DURATION = {
    SHORT: 200,
    MEDIUM: 300,
    LONG: 500,
  } as const;
  
  // 默认配置
  export const DEFAULT_CONFIG = {
    defaultActiveTab: 0,
    allowMultipleExpand: true,
    showOperations: true,
    showTooltips: true,
    autoSelectOnHover: false,
    validateOnChange: true,
    debounceTime: 300,
  } as const;
  
  // 路径分隔符
  export const PATH_SEPARATOR = '.';
  
  // 最大嵌套深度
  export const MAX_NESTING_DEPTH = 5;
  
  // 操作按钮大小
  export const OPERATION_BUTTON_SIZE = {
    width: 24,
    height: 24,
    padding: 4,
  } as const;